export default dec => "0x" + dec.toString(16).padStart(2, "0");



// WEBPACK FOOTER //
// ./src/lib/decHex.js